import { AdminChargeStagingStatus } from 'api/admin/charges/getCharges'

export function stagingLabel(status: AdminChargeStagingStatus): string {
  switch (status) {
    case 'ready':
      return 'Ready to invoice'
    case 'staged':
      return 'Staged'
    case 'not_ready':
      return 'Not ready'
    default: {
      const _exhaustive: never = status
      return _exhaustive
    }
  }
}

export function stagingTooltip(status: AdminChargeStagingStatus): string {
  switch (status) {
    case 'ready':
      return 'Eligible for the next automated invoice run'
    case 'staged':
      return 'Finalized, but the invoice run time has not been reached yet'
    case 'not_ready':
      return 'Not eligible for automated invoicing yet (for example, still open)'
    default: {
      const _exhaustive: never = status
      return _exhaustive
    }
  }
}

export function stagingVariant(
  status: AdminChargeStagingStatus
): 'success' | 'warning' | 'information' | 'none' {
  switch (status) {
    case 'ready':
      return 'success'
    case 'staged':
      return 'information'
    case 'not_ready':
      return 'warning'
    default: {
      const _exhaustive: never = status
      return _exhaustive
    }
  }
}
